import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Loader2, GitBranch } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { llmApi } from '@/api/llm';

interface ContextLimitPanelProps {
  conversationId: string;
}

export function ContextLimitPanel({ conversationId }: ContextLimitPanelProps) {
  const navigate = useNavigate();
  const [isCreating, setIsCreating] = useState(false);

  const handleContinue = async () => {
    setIsCreating(true);
    try {
      const newConversation = await llmApi.continueConversation(conversationId);
      toast.success('Новый чат создан', {
        description: 'Контекст перенесён в новую беседу',
      });
      navigate(`/more/chat/${newConversation.id}`);
    } catch (error: any) {
      toast.error('Ошибка', {
        description: error.response?.data?.message || 'Не удалось создать чат',
      });
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div className="p-4 bg-destructive/10 border-t border-destructive/30">
      <div className="flex items-start gap-3">
        <Lock className="w-5 h-5 text-destructive shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="font-medium text-destructive">Лимит контекста достигнут</p>
          <p className="text-sm text-muted-foreground mt-1">
            Чат заблокирован. Создайте новый чат с саммаризацией этого.
          </p>
          <Button
            size="sm"
            onClick={handleContinue}
            disabled={isCreating}
            className="mt-3"
          >
            {isCreating ? (
              <Loader2 className="w-4 h-4 animate-spin mr-2" />
            ) : (
              <GitBranch className="w-4 h-4 mr-2" />
            )}
            Продолжить в новом чате
          </Button>
        </div>
      </div>
    </div>
  );
}
